import React from "react";
import ChevronIcon from "../../../Common/Svgs/ChevronIcon";

const LabelAndValue = ({ label, value, onClick = null }) => {
  return (
    <div className="flex flex-col items-start gap-y-2 w-[137px]">
      <p className="font-aileron font-normal text-10 text-dark-gray capitalize">
        {label}
      </p>

      <div
        role={onClick ? "button" : "none"}
        className="flex items-center gap-x-2"
        onClick={() => {
          if (onClick) onClick();
        }}
      >
        <p className="font-aileron font-semibold text-xs text-black capitalize whitespace-nowrap">
          {value}
        </p>

        {onClick ? <ChevronIcon className="w-4 h-4 stroke-dark-gray" /> : null}
      </div>
    </div>
  );
};

export default LabelAndValue;
